// src/utils/timezones.js
export const getTimezones = () => {
  try {
    // Get all timezone names from Intl API
    const timezones = Intl.supportedValuesOf('timeZone');
    
    return timezones.map(tz => {
      try {
        // Get timezone offset
        const date = new Date();
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          timeZoneName: 'short'
        });
        
        const parts = formatter.formatToParts(date);
        const timeZoneName = parts.find(part => part.type === 'timeZoneName')?.value || '';
        
        // Calculate offset
        const offset = -date.getTimezoneOffset();
        const offsetHours = Math.floor(Math.abs(offset) / 60);
        const offsetMinutes = Math.abs(offset) % 60;
        const offsetSign = offset >= 0 ? '+' : '-';
        const offsetString = `GMT${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
        
        return {
          value: tz,
          label: `${tz.replace(/_/g, ' ')} (${offsetString})`,
          offset: offset,
          abbreviation: timeZoneName
        };
      } catch (e) {
        return {
          value: tz,
          label: tz.replace(/_/g, ' '),
          offset: 0,
          abbreviation: ''
        };
      }
    }).sort((a, b) => {
      // Sort by offset first, then by name
      if (a.offset !== b.offset) {
        return b.offset - a.offset;
      }
      return a.label.localeCompare(b.label);
    });
  } catch (error) {
    // Fallback to common timezones if Intl.supportedValuesOf is not available
    return [
      { value: 'America/New_York', label: 'America/New York (GMT-05:00)', offset: -300 },
      { value: 'America/Chicago', label: 'America/Chicago (GMT-06:00)', offset: -360 },
      { value: 'America/Denver', label: 'America/Denver (GMT-07:00)', offset: -420 },
      { value: 'America/Los_Angeles', label: 'America/Los Angeles (GMT-08:00)', offset: -480 },
      { value: 'Europe/London', label: 'Europe/London (GMT+00:00)', offset: 0 },
      { value: 'Europe/Paris', label: 'Europe/Paris (GMT+01:00)', offset: 60 },
      { value: 'Asia/Dubai', label: 'Asia/Dubai (GMT+04:00)', offset: 240 },
      { value: 'Asia/Kolkata', label: 'Asia/Kolkata (GMT+05:30)', offset: 330 },
      { value: 'Asia/Singapore', label: 'Asia/Singapore (GMT+08:00)', offset: 480 },
      { value: 'Asia/Tokyo', label: 'Asia/Tokyo (GMT+09:00)', offset: 540 },
      { value: 'Australia/Sydney', label: 'Australia/Sydney (GMT+11:00)', offset: 660 },
    ];
  }
};

// Get user's current timezone
export const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return 'UTC';
  }
};

// Format timezone for display
export const formatTimezone = (timezone) => {
  try {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(date);
    return parts.find(part => part.type === 'timeZoneName')?.value || timezone;
  } catch (e) {
    return timezone;
  }
};